import { Button as AntButton, Modal, Select } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { copySchedule, getSchedules } from '../../../../api/shuttleSetting.api';
import useAxios from '../../../../hooks/useAxios';
import useNotification from '../../../../hooks/useNotification';
import { IGetSchedules, ILine } from '../../../../models/shuttleSetting.model';
import { RootState } from '../../../../store/rootReducer';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  doGetSchedules: () => void;
  line: ILine | undefined;
}

const CopyWeekdayModal: FC<IProps> = ({
  visible,
  setVisible,
  doGetSchedules,
  line,
}) => {
  const { t, i18n } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0001 = 요일
  const SY0001 = commonCodes.find(
    (item) => item.commonCode === 'SY0001',
  )?.detailCode;
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetSchedules>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    execute: submitExecute,
  } = useAxios();

  const [fromWeekday, setFromWeekday] = useState<string>();
  const [toWeekday, setToWeekday] = useState<string>();

  useEffect(() => {
    if (res?.data && !isLoading) {
      const req: any = [];
      res.data.forEach((item) => {
        req.push({
          runningCode: item.runningCode,
          weekdayDiv: toWeekday,
        });
      });

      submitExecute(copySchedule(currentCampus, req));
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      doGetSchedules();
      successNotification(t('campus.shuttle.message17'));
      setVisible(false);
    }
  }, [submitRes, submitIsLoading]);

  const onClose = () => {
    setFromWeekday(undefined);
    setToWeekday(undefined);
    setVisible(false);
  };

  const onSubmit = () => {
    if (!fromWeekday || !toWeekday) {
      return infoNotification(t('campus.shuttle.message18'));
    }

    if (line) {
      execute(getSchedules(currentCampus, line.lineCode, fromWeekday));
    }
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('campus.shuttle.title8')}
        visible={visible}
        width={350}
        onCancel={onClose}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton key="submit" className='btn-basic pink' onClick={onSubmit}>
              {t('campus.shuttle.button3')}
            </AntButton>
            <AntButton key="cancel" className='btn-basic gray' onClick={onClose}>
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="flex flex-justify-center">
          <div className="v-line mr-1">From:</div>
          <div className="w-100p">
            <Select
              className="w-100"
              placeholder={t('campus.shuttle.placeholder4')}
              value={fromWeekday}
              onChange={(value) => setFromWeekday(value)}
            >
              {SY0001?.slice(1, 6).map((item: any) => {
                return (
                  <Select.Option key={item.detailCode} value={item.detailCode}>
                    {i18n.language === 'en' ? item.engName : item.korName}
                  </Select.Option>
                );
              })}
            </Select>
          </div>
          <div className="v-line ml-3 mr-1">To:</div>
          <div className="w-100p">
            <Select
              className="w-100"
              placeholder={t('campus.shuttle.placeholder4')}
              value={toWeekday}
              onChange={(value) => setToWeekday(value)}
            >
              {SY0001?.slice(1, 6).map((item: any) => {
                return (
                  <Select.Option key={item.detailCode} value={item.detailCode}>
                    {i18n.language === 'en' ? item.engName : item.korName}
                  </Select.Option>
                );
              })}
            </Select>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CopyWeekdayModal;
